import { styled } from '@mui/material/styles';
import Alert from '@mui/material/Alert';
import FormControl from '@mui/material/FormControl';
import FormHelperText from '@mui/material/FormHelperText';
import InputLabel from '@mui/material/InputLabel';
export var StyledAlert = styled(Alert)(function (_ref) {
  var edges = _ref.edges,
    theme = _ref.theme;
  return {
    color: theme.palette.secondary.contrastText,
    padding: theme.spacing(1),
    background: theme.palette.secondary.main,
    alignItems: 'center',
    marginTop: '2px',
    borderRadius: function borderRadius() {
      switch (edges) {
        case 'rounded':
          return 99;
        case 'sharp':
          return 0;
        default:
          return theme.shape.borderRadius;
      }
    },
    '& *': {
      padding: 0,
      fontSize: theme.typography.size.scale(3.6),
      marginRight: theme.spacing(0.5)
    },
    '& svg': {
      color: theme.palette.secondary.contrastText,
      verticalAlign: 'middle',
      height: '1.3em',
      width: '1.3em',
      position: 'relative',
      marginTop: '-0.15em'
    }
  };
});
export var StyledFormControl = styled(FormControl)(function (_ref2) {
  var disabled = _ref2.disabled,
    theme = _ref2.theme;
  return {
    pointerEvents: disabled ? 'none' : null,
    color: theme.palette.default.main,
    '& .MuiFilledInput-underline:before, & .MuiFilledInput-underline:after': {
      display: 'none'
    }
  };
});
export var StyledHelperText = styled(FormHelperText)(function (_ref3) {
  var theme = _ref3.theme;
  return {
    marginBottom: theme.spacing(1),
    marginLeft: 0,
    '& svg': {
      verticalAlign: 'middle',
      height: '1.3em',
      width: '1.3em',
      position: 'relative',
      marginTop: '-0.15em',
      fill: theme.palette.secondary.main
    }
  };
});
export var StyledInputLabel = styled(InputLabel)(function (_ref4) {
  var theme = _ref4.theme;
  return {
    fontSize: '13px',
    lineHeight: 1.1,
    fontWeight: 600,
    width: '100%',
    whiteSpace: 'normal',
    color: theme.palette.text.primary,
    transform: 'initial',
    transformOrigin: 'initial',
    overflow: 'initial',
    paddingBottom: '4px',
    marginBottom: theme.spacing(1),
    position: 'relative',
    '.MuiFormLabel-asterisk': {
      color: theme.palette.error.main
    }
  };
});